export default {
    Daily:'Day',
    Weekly:'Lane Condition',
}


// WEBPACK FOOTER //
// ./src/utils/constants/oilratiofrequency.js